<div class="chat">
  <p>
    If a product is unavailable, our agents won’t be able to order it for you.
    They have access to the same product information.
  </p>
  <p style="margin-top: 8px">
    If you need help choosing something else, live chat is available Monday to
    Friday 8am-6pm, and Saturday 8.30am-4.30pm.
  </p>
  <dgx-components-button
    (clicked)="openChat()"
    [tabIndex]="0"
    [type]="'button-text'"
    [fill]="true"
    variant="secondary"
    class="chat-button"
  >
    Start chat
  </dgx-components-button>
  <p>or give us a call:</p>
  <div class="phone-link" [ngClass]="{ desktop: !isMobile }">
    <dgx-components-icon name="phone" size="sm"></dgx-components-icon>
    <a [attr.href]="isMobile ? 'tel:0333 000 4970' : null">
      <span>0333 000 4970*</span>
    </a>
  </div>
  <small class="call-cost">
    *Calls cost the basic rate per minute plus your phone company’s access
    charge. From a mobile, they can cost much more. Calls to 0800 numbers are
    always free.
  </small>
</div>
